// A small, always-present fullscreen toggle (top-right) — and the `F` key — so the game can
// fill the actual screen (browser chrome hidden), not just the window. Fullscreen requires a
// user gesture, so it's wired to a click / keypress rather than triggered on load.

import { injectTheme } from "./theme.js";

async function toggleFullscreen(): Promise<void> {
  try {
    if (!document.fullscreenElement) await document.documentElement.requestFullscreen();
    else await document.exitFullscreen();
  } catch { /* browser blocked / unsupported — ignore */ }
}

export function mountFullscreenButton(): void {
  injectTheme();
  if (document.getElementById("gl-fs")) return;
  const btn = document.createElement("button");
  btn.id = "gl-fs";
  btn.title = "Fullscreen (F)";
  btn.textContent = "⛶";
  btn.style.cssText =
    "position:fixed;top:14px;right:14px;z-index:45;width:34px;height:34px;" +
    "display:flex;align-items:center;justify-content:center;" +
    "background:var(--gl-panel);border:1px solid var(--gl-border);border-radius:8px;" +
    "color:var(--gl-text);font-size:15px;cursor:pointer;opacity:.55;transition:opacity .12s,border-color .12s;";
  btn.addEventListener("mouseenter", () => { btn.style.opacity = "1"; btn.style.borderColor = "var(--gl-border-focus)"; });
  btn.addEventListener("mouseleave", () => { btn.style.opacity = ".55"; btn.style.borderColor = "var(--gl-border)"; });
  btn.addEventListener("click", () => void toggleFullscreen());
  document.body.appendChild(btn);

  window.addEventListener("keydown", (e) => {
    if ((e.key === "f" || e.key === "F") && !(e.target instanceof HTMLInputElement)) void toggleFullscreen();
  });
}
